import { Routes, Route } from 'react-router-dom';
import Dashboard from './frontend/pages/dashboard/Dashboard';
import { AuthProvider } from "./contexts/AuthContext";
import { AuthProvider as AdminAuthProvider } from "./admin/auth/AuthContext";
import Signin from './frontend/pages/signin/Signin';
import Signup from './frontend/pages/signup/Signup';
import PrivateRoute from './frontend/utils/PrivateRoute';
import Profile from './frontend/pages/profile/Profile';
import WhatsappSettings from './frontend/pages/whatsapp-config/WhatsappSettings';
import { TypebotIdProvider } from './contexts/TypebotIdContext';
import Payment from './frontend/pages/payment/Payment';
import { InactiveRoute } from './frontend/utils/InactiveRoute';
import TermsPolicy from './frontend/pages/terms-policy/TermsPolicy';
import './App.css';
import MarketingPage from './frontend/pages/home/MarketingPage';
import Tutorials from './frontend/pages/tutorials/Tutorials';
import { NewEmailProvider } from './frontend/globalStates/NewEmail';
import { useInactivityLogout } from './contexts/logoutByInactivity';
import ResetIndex from './frontend/pages/resetEmailOrPassword/ResetIndex';
import AboutUs from './frontend/pages/about-us/AboutUs';
import NotFound from './frontend/pages/not-found/NotFound';
import { NoWhatsapp } from './frontend/utils/NoWhatsapp';
import FlowModels from './frontend/pages/flow-models/FlowModels';
import LoginPage from './admin/pages/LoginPage';
import DashboardPage from './admin/pages/DashboardPage';
import SubmissionDetailPage from './admin/pages/SubmissionDetailPage';
import ProtectedRoute from './admin/components/ProtectedRoute';
import MainPageForm from './frontend/pages/forms/MainPageForm';

function InactivityWrapper() {
  useInactivityLogout();
  return null;
}

function App() {
  return (
    <AuthProvider>
      <InactivityWrapper />
      <NewEmailProvider>
        <Routes>
          <Route path='/' element={<MarketingPage />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path='/dashboard' element={
            <PrivateRoute>
              <NoWhatsapp>
                <Dashboard />
              </NoWhatsapp>
            </PrivateRoute>
          }
          />
          <Route path='/profile' element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
          />
          <Route path='/tutorials' element={
            <PrivateRoute>
              <NoWhatsapp>
                <Tutorials />
              </NoWhatsapp>
            </PrivateRoute>
          }
          />
          <Route path='/whatsapp-settings' element={
            <PrivateRoute>
              <NoWhatsapp>
                <InactiveRoute>
                  <TypebotIdProvider>
                    <WhatsappSettings />
                  </TypebotIdProvider>
                </InactiveRoute>
              </NoWhatsapp>
            </PrivateRoute>
          }
          />
          <Route path='/payment' element={
            <PrivateRoute>
              <NoWhatsapp>
                <Payment />
              </NoWhatsapp>
            </PrivateRoute>
          }
          />
          <Route path='/flow-models' element={
            <PrivateRoute>
              <NoWhatsapp>
                <FlowModels />
              </NoWhatsapp>
            </PrivateRoute>
          }
          />
          <Route path='/forms' element={
            <PrivateRoute>
              {/* <InactiveRoute> */}
                <MainPageForm />
              {/* </InactiveRoute> */}
            </PrivateRoute>
          }
          />

          {/* Rotas administrativas */}
          <Route path='/admin/login' element={
            <AdminAuthProvider>
              <LoginPage />
            </AdminAuthProvider>
          } />
          <Route path='/admin/dashboard' element={
            <AdminAuthProvider>
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            </AdminAuthProvider>
          } />
          <Route path='/admin/submissions/:id' element={
            <AdminAuthProvider>
              <ProtectedRoute>
                <SubmissionDetailPage />
              </ProtectedRoute>
            </AdminAuthProvider>
          } />

          <Route path='/terms' element={<TermsPolicy />} />
          <Route path='/about-us' element={<AboutUs />} />
          <Route path='/reset-user' element={<ResetIndex />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </NewEmailProvider>
    </AuthProvider>
  )
}

export default App;